import { NextPage } from 'next';

import { PublicFormCard, PageLayout } from '../components';

const ForgotPassword: NextPage = () => {
  return (
    <PageLayout title="Forgot password">
      <section className="flex flex-col min-h-screen bg-gradient-wave bg-gradient-wave--whole pt-40">
        <div className="c-container">
          <PublicFormCard description="Enter your email below and we'll send you a link to reset your password" title="Forgot password" />
        </div>
      </section>
    </PageLayout>
  );
};

// eslint-disable-next-line import/no-default-export
export default ForgotPassword;
